import { FC, Fragment, useContext, useEffect, useRef, useState } from "react";
import { Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import PoolCard from "./PoolCard";
import PoolContext from "../../store/Pool/PoolContext";
import {
  validateUser,
  validateUserWhitelist,
} from "../../helpers/validateUser";
import Pagination from "../../helpers/Pagination";
import SkeletonCard from "./PoolsCardSkeleton";
import EmptyDealsBg from "../../assets/images/emptyDealsBg.png";
import BuyGainModel from "../Modals/BuyGainModel";
import EmptyPools from "./EmptyPools";
import NoDataFound from "../../helpers/NoDataFound";
import { MdOutlineRefresh } from "react-icons/md";

// TODO: Pools props interface

const useStyles = makeStyles((theme) => ({
  emptyDeals: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: "0 5rem",
    width: "100%",
    gap: ".75rem",
    height: "18.25rem",
    background: `url(${EmptyDealsBg})`,
    backgroundRepeat: "no-repeat !important",

    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 1rem",
      margin: "0 1rem",
      width: "100%",
      backgroundPosition: "50% 20%",
      justifyContent: "center",
      borderRadius: "1rem",
      height: "16rem",
    },
  },
  learnMoreBtn: {
    width: "8.75rem",
    fontSize: "0.875rem",
    height: "2.5rem",
    marginBottom: "5rem",
    marginRight: ".75rem",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "0rem",
    },
  },
  buyGainsButton: {
    backgroundColor: "transparent",
    color: "rgba(17, 48, 45, 1)",
    border: "1px solid rgba(17, 48, 45, 0.2)",
    height: "2.5rem",
    fontSize: "0.875rem",
  },
}));

const LivePools: FC<any> = ({
  quizzes,
  pledgeData,
  dealPage,
  setOpenLoginModal,
  statusPop,
}) => {
  const statusRef = useRef<any>(null);

  const {
    livePools: ongoingPools,
    fetchMoreLivePools,
    totalLivePosts,
    isLivePoolsLoading,
    livePoolsError,
  } = useContext<any>(PoolContext);

  const postsPerRow: number = 3;
  const emptyArray = Array(postsPerRow).fill({});

  const classes = useStyles();

  const [noData, setNoData] = useState<boolean>(false);
  const [openBuy, setOpenBuy] = useState<boolean>(false);

  useEffect(() => {
    statusPop(statusRef);
  });

  useEffect(() => {
    if (ongoingPools.length <= 0) setNoData(true);
    else setNoData(false);
  }, [ongoingPools]);

  function handleClickPagination() {
    fetchMoreLivePools();
  }

  const totalPools = ongoingPools.length;

  function refreshPage(): void {
    window.location.reload();
  }

  if (livePoolsError) return (
    <Grid
      container
      spacing={3}
      direction="row"
    >
      <Grid
        item
        style={{
          width: "100%",
        }}
      >
        <Typography
          variant="h3"
          style={{
            textAlign: "center",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Oops, we were unable to display the data. Refresh now {
            <IconButton
              color="primary"
              onClick={refreshPage}
              aria-label="refresh"
            >
              <MdOutlineRefresh />
            </IconButton>
          } or please try again later.
        </Typography>
      </Grid>
    </Grid>
  )

  if (totalPools === 0 && isLivePoolsLoading && !livePoolsError) return (
    <Grid
        container
        justifyContent="center"
        spacing={3}
        style={{
          marginTop: "10px",
        }}
      >
        {
          emptyArray.map((_, i: number) => (
            <Grid item key={i} lg={4} md={4} sm={6} xs={12}>
              <SkeletonCard />
            </Grid>
        ))}
      </Grid>
  )

  if (totalPools === 0 && !isLivePoolsLoading && !livePoolsError) return (
    <Grid container direction="row">
      <EmptyPools setOpenBuy={setOpenBuy} />
      <BuyGainModel open={openBuy} setOpen={setOpenBuy} />
    </Grid>
  )

  return (
    <>
      <Grid
        container
        spacing={3}
        direction="row"
      >
        
          <>
            {
              ongoingPools.map((pool: any, index: any) => {
                  const {
                    id,
                    slug,
                    image,
                    banner,
                    name,
                    description,
                    contributionStartDate,
                    contributionEndDate,
                    pledgeStartDate,
                    pledgeEndDate,
                    maxRaise,
                    totalCap,
                    status,
                    kycDeadlineDate,
                    kycUrl,
                    networks,
                    socialNetworks,
                    usdPerTicketValue,
                    distributionScAddress,
                    refundPolicy,
                    isExternalProject,
                    code,
                  } = pool;
                  return (
                    <Fragment key={index}>
                      {noData ? (
                        <NoDataFound title="No more pools available!" />
                      ) : (
                        <PoolCard
                          key={id}
                          pool={pool}
                          id={id}
                          slug={slug}
                          title={name}
                          description={description}
                          imgSrc={image}
                          banner={banner}
                          progress={true}
                          live={contributionEndDate}
                          totalCap={totalCap}
                          totalRaise={maxRaise}
                          status={status}
                          kycDeadlineDate={kycDeadlineDate}
                          kycUrl={kycUrl}
                          networks={networks}
                          pledgeStartDate={pledgeStartDate}
                          pledgeEndDate={pledgeEndDate}
                          contributionStartDate={contributionStartDate}
                          socialNetworks={socialNetworks}
                          investBtn={validateUser(id, pledgeData)}
                          quizResult={quizzes?.filter(
                            (quiz: any) => quiz.poolId === id
                          )}
                          getWhitelisted={
                            status === "whitelist_open" ||
                            status === "whitelist_closed" ||
                            status === "upcoming"
                          }
                          whitelistedCompleted={validateUserWhitelist(
                            id,
                            pledgeData
                          )}
                          statusRef={statusRef}
                          usdPerTicketValue={usdPerTicketValue}
                          distributionScAddress={distributionScAddress}
                          refundPolicy={refundPolicy}
                          isExternalProject={isExternalProject}
                          code={code}
                        />
                      )}
                    </Fragment>
                  );
                })
              }
          </>
      </Grid>
      <Grid
        container
        justifyContent="center"
        spacing={3}
        style={{
          marginTop: "10px",
        }}
      >
        {isLivePoolsLoading &&
          emptyArray.map((_, i: number) => (
            <Grid item key={i} lg={4} md={4} sm={6} xs={12}>
              <SkeletonCard />
            </Grid>
          ))}
        {((!dealPage && totalPools < totalLivePosts) ||
          isLivePoolsLoading) && (
          <Pagination
            handleClick={() => handleClickPagination()}
            isLoading={isLivePoolsLoading}
          />
        )}
      </Grid>
    </>
  );
};

export default LivePools;
